module.exports = "https://trybtryb-legacy.web.app/img/youtube.22a97878.svg";